<div class="profile-selector relative" *ngIf="canSwitchProfiles">
  <!-- Indicador de modo visualização -->
  <div
    *ngIf="isViewModeActive"
    class="view-mode-indicator flex items-center gap-2 p-1 px-3 rounded-full text-xs font-medium bg-amber-100 text-amber-800 mb-2 animate-pulse"
  >
    <app-icon name="visibility" [size]="16"></app-icon>
    <span>Modo Visualização</span>
  </div>

  <!-- Botão seletor de perfil -->
  <button
    *ngIf="currentProfile"
    (click)="toggleDropdown($event)"
    class="profile-button flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors w-full"
    [class.border-primary-500]="isViewModeActive"
    [class.bg-primary-50]="isViewModeActive"
  >
    <!-- Ícone do Perfil -->
    <div
      class="profile-icon w-8 h-8 rounded-full flex items-center justify-center"
      [ngClass]="{
        'bg-primary-100 text-primary-700':
          currentProfile.role === 'ESTOKAI_OWNER',
        'bg-blue-100 text-blue-700': currentProfile.role === 'dono',
        'bg-green-100 text-green-700': currentProfile.role === 'gerente',
        'bg-orange-100 text-orange-700': currentProfile.role === 'vendedor'
      }"
    >
      <app-icon
        [name]="getRoleIcon(currentProfile.role)"
        [size]="18"
      ></app-icon>
    </div>

    <!-- Informação do Perfil -->
    <div class="profile-info flex-1 text-left">
      <div class="text-sm font-medium text-gray-900">
        {{ currentProfile.displayName }}
      </div>
      <div class="text-xs text-gray-500 truncate max-w-[150px]">
        {{ currentProfile.description }}
      </div>
    </div>

    <!-- Ícone de Seta -->
    <app-icon
      [name]="isDropdownOpen ? 'expand_less' : 'expand_more'"
      color="gray"
      [size]="20"
    ></app-icon>
  </button>

  <!-- Dropdown de Perfis -->
  <div
    *ngIf="isDropdownOpen"
    class="profile-dropdown absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50"
  >
    <div class="dropdown-header p-3 border-b border-gray-100">
      <h4 class="text-sm font-semibold text-gray-900">Trocar Visualização</h4>
      <p class="text-xs text-gray-500 mt-1">
        Veja o sistema da perspectiva de diferentes perfis
      </p>
    </div>

    <div class="profile-options max-h-[320px] overflow-y-auto">
      <!-- Opção para cada perfil -->
      <button
        *ngFor="let profile of availableProfiles"
        (click)="switchProfile(profile.role)"
        class="profile-option flex items-center gap-3 px-4 py-3 w-full hover:bg-gray-50 transition-colors"
        [class.bg-primary-50]="profile.role === currentProfile?.role"
      >
        <!-- Ícone do Perfil -->
        <div
          class="option-icon w-8 h-8 rounded-full flex items-center justify-center"
          [ngClass]="{
            'bg-primary-100 text-primary-700': profile.role === 'ESTOKAI_OWNER',
            'bg-blue-100 text-blue-700': profile.role === 'dono',
            'bg-green-100 text-green-700': profile.role === 'gerente',
            'bg-orange-100 text-orange-700': profile.role === 'vendedor'
          }"
        >
          <app-icon [name]="getRoleIcon(profile.role)" [size]="18"></app-icon>
        </div>

        <!-- Informação do Perfil -->
        <div class="option-info flex-1 text-left">
          <div class="text-sm font-medium text-gray-900">
            {{ profile.displayName }}
          </div>
          <div class="text-xs text-gray-500">{{ profile.description }}</div>
        </div>

        <!-- Indicador de Seleção -->
        <app-icon
          *ngIf="profile.role === currentProfile?.role"
          name="check_circle"
          color="primary"
          [size]="16"
        ></app-icon>
      </button>
    </div>

    <!-- Botão para resetar visualização -->
    <div *ngIf="isViewModeActive" class="border-t border-gray-100 p-2">
      <button
        (click)="resetToOriginalView()"
        class="flex items-center gap-2 px-4 py-2 w-full text-primary-600 hover:bg-primary-50 rounded-md transition-colors text-sm font-medium"
      >
        <app-icon name="refresh" color="primary" [size]="16"></app-icon>
        <span>Voltar ao Original</span>
      </button>
    </div>
  </div>
</div>
